import React from 'react';
import DialogGenericFG from '../../../components/common/DialogGenericFG';
import styled from 'styled-components';
import { Button } from '@mui/material';

const CancelDialog = (props) => {
    const { open, onClose, onConfirm } = props;
    return (
        <>
            <DialogGenericFG
                message={
                    <WrapperDialog>
                        <p>Está a punto de cancelar la orden de liquidación</p>
                        <Button
                            onClick={onConfirm}
                            fullWidth
                            color="primary"
                            variant="contained"
                        >
                            Aceptar
                        </Button>
                    </WrapperDialog>
                }
                open={open}
                title="Orden de liquidación"
                handleClose={onClose}
                customColor="#fafafa"
                titleColor="#b31d15"
                transitionType="grow"
            />
        </>
    );
};

export default CancelDialog;

const WrapperDialog = styled.div`
    width: calc(100% - 4rem);
    display: flex;
    flex-direction: column;
    gap: 2rem;
    margin: 0 auto;
    padding: 0 2rem;
`;
